import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.66574 10.3021L5.57187 12.3959C4.78987 13.1779 4.34017 14.242 4.34839 15.3602C4.35661 16.4785 4.79647 17.549 5.61557 18.3428C6.40934 19.162 7.48009 19.6018 8.59817 19.61C9.74175 19.6184 10.7806 19.1941 11.5626 18.412L13.6565 16.3182M16.331 13.6948L18.4249 11.601C19.2069 10.819 19.6566 9.75493 19.6484 8.63667C19.6402 7.5184 19.2003 6.44788 18.3812 5.65407C17.5876 4.86049 16.517 4.42061 15.3988 4.41239C14.2805 4.40417 13.2163 4.82835 12.4343 5.61037L10.3404 7.70423M8.82317 15.1177L15.1048 8.83608",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }